export const COL_TYPE = {
  BAND_COLUMN: "BAND_COLUMN",
  SCALE_COLUMN: "SCALE_COLUMN",
};

export const CELL_TYPE = {
  DIALYSIS_PATH: "DIALYSIS_PATH",
  DIALYSIS_HOLDER: "DIALYSIS_HOLDER",
  LABEL_CELL: "LABEL_CELL",
};

export const DIALYSIS_TYPE = {
  SCALE: "SCALE",
  LABEL: "LABEL",
  FIXED: "FIXED",
  DRAGGABLE: "DRAGGABLE",
};

export const DIALYSIS_DRAG_DROP = {
  DIALYSIS_ID: "DIALYSIS_ID",
  CELL_ID: "CELL_ID",
  COL_ID: "COL_ID",
};

export const INITIAL_STATE = {
  dialysisPathHeight: 1,
  dialysisPathPadding: 1,
  dialysisHolderBoxHeight: 1,
  rangeTop: 1,
  rangeBottom: 1,
};

export const DIALYSIS_PATH_MIN_HEIGHT = 0;

export const THEME = {
  DARK: "DARK",
  LIGHT: "LIGHT",
};
